const COOKIE_KEY = 'tera_cookie_consent_dismissed';
const COOKIE_BANNER_SELECTOR = '[data-cookie-banner]';
const COOKIE_DISMISS_SELECTOR = '[data-cookie-dismiss]';
const COOKIE_VISIBLE_CLASS = 'cookie-banner-visible';

const setCookieBannerOffset = (cookieBanner) => {
    if (!cookieBanner || !cookieBanner.classList.contains('is-visible')) {
        document.documentElement.style.removeProperty('--cookie-banner-height');
        return;
    }

    document.documentElement.style.setProperty('--cookie-banner-height', `${cookieBanner.offsetHeight}px`);
};

const hideCookieBanner = (cookieBanner) => {
    cookieBanner.classList.remove('is-visible');
    cookieBanner.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(COOKIE_VISIBLE_CLASS);
    setCookieBannerOffset(cookieBanner);

    try {
        localStorage.setItem(COOKIE_KEY, '1');
    } catch (error) {}

    setTimeout(() => {
        cookieBanner.remove();
    }, 700);
};

const initCookieConsentBanner = () => {
    const cookieBanner = document.querySelector(COOKIE_BANNER_SELECTOR);

    if (!cookieBanner) {
        return;
    }

    let dismissed = false;

    try {
        dismissed = localStorage.getItem(COOKIE_KEY) === '1';
    } catch (error) {}

    if (dismissed) {
        cookieBanner.remove();
        return;
    }

    setTimeout(() => {
        cookieBanner.classList.add('is-visible');
        cookieBanner.setAttribute('aria-hidden', 'false');
        document.body.classList.add(COOKIE_VISIBLE_CLASS);
        setCookieBannerOffset(cookieBanner);
    }, 900);

    window.addEventListener('resize', () => setCookieBannerOffset(cookieBanner));

    cookieBanner.addEventListener('click', (event) => {
        const target = event.target;

        if (!(target instanceof Element) || !target.closest(COOKIE_DISMISS_SELECTOR)) {
            return;
        }

        hideCookieBanner(cookieBanner);
    });
};

document.addEventListener('DOMContentLoaded', initCookieConsentBanner);
